module.exports = __webpack_public_path__ + "img/Feature.639ca75b.jpg";